import http, { request } from "@config/http";
import { Page, Pagination } from "@services/common/model/page.model";

import {
  LoginPayloadModel,
  LoginResponseModel,
  VerificationModel,
  UserModel,
  RegisterPayloadModel,
  CheckVerificationModel,
} from "./model/user.model";

export const loginApi = async (params: LoginPayloadModel) => {
  return http.post<null, Page<LoginResponseModel>>("user/login", {
    ...params,
  });
};

export const logoutApi = async () => {
  return http.post<null, Page<null>>("user/logout", {});
};

export const sendVerificationApi = async (params: VerificationModel) => {
  return http.post<null, Page<LoginResponseModel>>("user/send_verification", {
    ...params,
  });
};

export const getUserInfoApi = async () => {
  return request.get<null, Page<{ username: string }>>(
    "lite/lite_user/info",
    {}
  );
};

export const registerApi = async (params: RegisterPayloadModel) => {
  return http.post<null, Page<null>>("user", {
    ...params,
  });
};

export const checkUsernameApi = async (user_name: string) => {
  return http.get<null, Page<null>>(`user/check_name/${user_name}`);
};

export const checkEmailApi = async (email: string) => {
  return http.get<null, Page<null>>(`user/check_email/${email}`);
};

export const checkPhoneApi = async (phone: string) => {
  return http.get<null, Page<null>>(`user/check_phone/${phone}`);
};

export const checkVerificationApi = async (params: CheckVerificationModel) => {
  return http.post<null, Page<null>>(`user/check_verification`, {
    ...params,
  });
};
